const titleBase = {
  fontSize: '22px',
  fontWeight: 600,
};

const sxStyles = theme => ({
  container: {
    mt: 2,
    mb: 2,
    p: { xs: 1, sm: 2 },
    width: { xs: '100%', sm: '98%' },
    minHeight: { xs: '250px', md: '300px' },
    bgcolor: '#fff',
    borderRadius: 2,
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    mx: 'auto',
  },
  iconError: {
    color: '#FF2020',
    mb: 1,
    fontSize: { xs: '50px', sm: '80px' },
  },
  iconSuccess: {
    color: '#03C868',
    fontSize: { xs: '50px', sm: '80px' },
  },
  iconWarning: {
    color: '#F5A623',
    mb: 1,
    fontSize: { xs: '50px', sm: '80px' },
  },
  verItinerarioButton: {
    width: '100%',
    bgcolor: '#fff',
    border: '2px solid #000',
    borderRadius: '12px',
    color: '#000',
    fontWeight: 600,
    fontSize: '1rem',
    '&:hover': {
      color: theme.text1,
      border: `2px solid ${theme.primary}`,
      bgcolor: theme.primary,
    },
    mt: 1,
    mb: 1,
  },

  titleSuccess: {
    ...titleBase,
    color: '#000',
  },

  titleError: {
    ...titleBase,
    color: '#FF2020',
  },

  titleWarning: {
    ...titleBase,
    color: '#ED6C02',
  },

  typography: {
    fontSize: { xs: '16px', sm: '18px' },
    fontWeight: 500,
    color: '#000',
    mb: 1,
  },

  codeText: {
    fontWeight: 600,
    color: theme.tertiary,
    fontSize: { xs: '16px', sm: '18px' },
  },
});

export default sxStyles;
